import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "button", "icon"]

  connect() {
    // All panels start collapsed
    this.panelTargets.forEach(panel => {
      panel.style.display = 'none'
    })
  }

  toggle(event) {
    const button = event.currentTarget
    const panel = this.panelTargets.find(p => p.id === button.getAttribute('aria-controls'))
    const icon = this.iconTargets.find(i => i === button.querySelector('svg'))

    const isExpanded = button.getAttribute('aria-expanded') === 'true'
    button.setAttribute('aria-expanded', !isExpanded)
    panel.style.display = isExpanded ? 'none' : 'block'
    
    if (icon) {
      icon.classList.toggle('rotate-180')
    }
  }
}